import ServicesHero  from '../components/services/ServicesHero'
import ServiceCard   from '../components/services/ServiceCard'
import WhyChooseUs   from '../components/services/WhyChooseUs'
import SectionTitle  from '../components/ui/SectionTitle'
import CTA           from '../components/home/CTA'
import { useServices } from '../hooks/useServices'

const FALLBACK_SERVICES = [
  { id: 1, icon: '🎈', color: '#FF6BB5', title: 'Balloon Decoration',   description: 'Themed balloon arches, columns, centerpieces, and ceiling arrangements tailored to any birthday theme.' },
  { id: 2, icon: '🎭', color: '#7C3AFF', title: 'Puppet Theater Show',  description: 'Professional live puppet shows that captivate children with interactive storytelling and beloved characters.' },
  { id: 3, icon: '🎩', color: '#FFC300', title: 'Magic Show',           description: 'A professional magician performs age-appropriate tricks that leave children amazed and delighted.' },
  { id: 4, icon: '🎵', color: '#22C55E', title: 'DJ & Music',           description: "High-energy DJ sets, children's songs, and interactive dance games to keep the party alive." },
  { id: 5, icon: '📸', color: '#FF6BB5', title: 'Photography & Video',  description: 'Professional coverage of every magical moment, delivered as printed photos and/or digital video.' },
  { id: 6, icon: '🎮', color: '#7C3AFF', title: 'Tele-match Games',     description: 'Structured, fun competitive games hosted by our team — perfect for all ages.' },
]

export default function Services() {
  const { data: services, isLoading } = useServices()
  const items = services?.length ? services : FALLBACK_SERVICES

  return (
    <>
      <ServicesHero />

      {/* Services 2x3 grid */}
      <section className="section-padding bg-surface">
        <div className="container-custom">
          <SectionTitle
            eyebrow="What We Do"
            title="Our Services"
            subtitle="Everything your celebration needs in one place — decoration, entertainment, games, and unforgettable memories."
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {(isLoading ? Array(6).fill(null) : items.slice(0, 6)).map((service, i) =>
              isLoading ? (
                <div key={i} className="h-64 skeleton" />
              ) : (
                <ServiceCard key={service.id} service={service} index={i} />
              )
            )}
          </div>
        </div>
      </section>

      <WhyChooseUs />
      <CTA />
    </>
  )
}
